import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable import/no-cycle */
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setUserAccountAction, setOriginalUserAccountDataAction, } from "Root/profile/redux/actionCreators/makeActionCreator";
import ProfileDataCardTitle from "../../common/ProfileDataCardTitle/ProfileDataCardTitle";
import ProfileBasicsDataCardItem from "../../MyProfile/BasicsComponent/ProfileBasicsDataCardItem";
import PromoComponent from "../../../../checkout/components/PromoComponent";
import useYourSubscriptionPage from "../../SubscriptionPageV2/YourSubscriptionV2/useYourSubscriptionV2";
import styles from "./styles.module.scss";
const GiftCardSection = () => {
    const userAccount = useSelector((state) => state.accountSettings.userAccount);
    const { applyPromo, removePromo, discountStr, setDiscountString } = useYourSubscriptionPage();
    const giftCardBalance = `$${Number(userAccount.giftCardBalance / 100).toFixed(2)}`;
    const dispatch = useDispatch();
    const applyGiftCard = async (promo) => {
        await applyPromo(promo);
        const data = {
            ...userAccount,
        };
        dispatch(setUserAccountAction(data));
        dispatch(setOriginalUserAccountDataAction(data));
    };
    const removeGiftCard = async (promo) => {
        await removePromo(promo);
        const data = {
            ...userAccount,
        };
        dispatch(setUserAccountAction(data));
        dispatch(setOriginalUserAccountDataAction(data));
    };
    return (_jsxs("div", { className: "my-profile__basics-container my-profile__basics", children: [_jsx(ProfileDataCardTitle, { title: "Gift Cards", editMode: false, name: "giftCards" }), _jsx("div", { className: "my-profile__items-wrapper", children: userAccount.giftCardBalance > 0 && (_jsx(ProfileBasicsDataCardItem, { editMode: false, value: giftCardBalance, label: "Gift Card Balance", type: "", onInputChange: () => { }, name: "" })) }), _jsxs("div", { className: styles.giftcard, children: [_jsx("div", { className: "my-profile__input-label", children: "Gift Card" }), _jsx(PromoComponent, { applyPromo: applyGiftCard, removePromo: removeGiftCard, discountStr: [], setDiscountStr: () => { }, isGiftCard: true })] })] }));
};
export default GiftCardSection;
